import { FragranceOption } from './types';

export const fragranceColourConceptOptions: FragranceOption[] = [
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:black',
    value: 'black',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:silver',
    value: 'silver',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:white',
    value: 'white',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:blue',
    value: 'blue',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:yellow',
    value: 'yellow',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:pink',
    value: 'pink',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:purple',
    value: 'purple',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:green',
    value: 'green',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:orange',
    value: 'orange',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:gold',
    value: 'gold',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:natural',
    value: 'natural',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:clean',
    value: 'clean',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:care',
    value: 'care',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:hygiene',
    value: 'hygienee',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:malodour',
    value: 'malodour',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:performance',
    value: 'performance',
  },
  {
    name: 'topics:fragrance:options:availableColoursOrConcepts:premium',
    value: 'premium',
  },
];
